import { render, staticRenderFns } from "./StockOverviewWidget.vue?vue&type=template&id=3a92193f&v-slot%3Abottom=true&"
import script from "./StockOverviewWidget.vue?vue&type=script&lang=js&"
export * from "./StockOverviewWidget.vue?vue&type=script&lang=js&"
import style0 from "./StockOverviewWidget.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtnToggle,QSeparator,QSelect,QItem,QItemSection,QInput,QBtn,QToggle,QSpinner,QTable,QTr,QTh,QTd,QDialog,QSpace,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QBtnToggle,QSeparator,QSelect,QItem,QItemSection,QInput,QBtn,QToggle,QSpinner,QTable,QTr,QTh,QTd,QDialog,QSpace,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
